import React from "react";
import { Col, Card, CardHeader, Row, Button } from "../../components/ui";
import { Link } from "react-router-dom";
import { getAllEnabledProducts } from "../../api";

export default class PlansCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
    };
  }

  componentDidMount = async () => {
    const products = await getAllEnabledProducts();
    this.setState({ products: products.data });
  };

  plan = (billingCycle) => {
    if (billingCycle === 12 || billingCycle === 365) {
      return { name: "Yearly", interval: "billed every year (45% Discount)" };
    } else if (billingCycle === 1 || billingCycle === 30) {
      return { name: "Monthly", interval: "billed every month" };
    } else if (billingCycle === 3 || billingCycle === 92) {
      return { name: "Quarterly", interval: "billed every quarter" };
    } else {
      return {};
    }
  };

  render() {
    return (
      <Row
        style={{
          paddingBottom: this.props.noPadding ? {} : "154px",
          paddingTop: this.props.paddingTop,
        }}
        className="justify-content-md-center"
      >
        {this.state.products.map((plan, idx) => (
          <Col md={{ size: 4 }}>
            <Card
              small
              style={{
                backgroundColor: this.props.bg,
                boxShadow: "none",
                height: 490,
                marginLeft: "auto",
                marginBottom: "15px",
                borderRadius: "10px",
                fontFamily: "Josefin Sans",
                border:
                  plan.name.toLowerCase() === "quarterly"
                    ? "7px solid #F15922"
                    : "",
              }}
            >
              <CardHeader
                className="text-center"
                style={{ backgroundColor: this.props.bg, padding: 0 }}
              >
                {plan.name.toLowerCase() === "quarterly" && (
                  <label
                    style={{
                      width: "100%",
                      background: "#F15922",
                      color: "#fff",
                      marginBottom: 0,
                      fontSize: 20,
                      border: "1px solid #F15922",
                    }}
                  >
                    Most Popular
                  </label>
                )}
                <h5
                  style={{
                    color: "black",
                    fontSize: 24,
                    fontStyle: "normal",
                    textTransform: "uppercase",
                    paddingBottom: 22,
                    paddingTop: 22,
                    fontWeight: "bolder",
                    borderBottom: "2px solid #F1F1F1",
                    marginBottom: 35,
                    fontFamily: "Josefin Sans",
                  }}
                >
                  {plan.name.toUpperCase()}
                </h5>
                <Button
                  pill
                  outline
                  size="sm"
                  className="mb-2"
                  style={{
                    border: "#BE00FF",
                    backgroundColor: "#F8E5FF",
                    color: "#BE00FF",
                  }}
                >
                  {plan.marketingPhrase}{" "}
                </Button>
                <span
                  style={{ color: "#757575", marginTop: 10 }}
                  className="text-muted d-block mb-2"
                >
                  {this.plan(plan.billingCycle).interval}
                </span>
                <h4
                  style={{
                    color: "#29293A",
                    fontSize: 35,
                    lineHeight: "52px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  <b style={{ color: "#757575" }}>$</b>
                  {plan.cost}
                </h4>
              </CardHeader>
              <div
                style={{
                  paddingLeft: 24,
                  paddingRight: 24,
                  textAlign: "center",
                  flexGrow: 1,
                  paddingTop: 15,
                }}
              >
                {plan.description}
              </div>
              <Link
                to={`/register?planId=${plan.id}`}
                className="bitcoin-linear"
                style={style.defaultBtn}
              >
                Get Started
              </Link>
            </Card>
          </Col>
        ))}
      </Row>
    );
  }
}

const style = {
  defaultBtn: {
    margin: 25,
    paddingTop: 10,
    paddingBottom: 16,
    fontSize: 16,
    lineHeight: "28px",
    border: "none",
    color: "white",
    textAlign: "center",
    marginBottom: 25,
    background: "#F15922",
    borderRadius: "12px",
  },
};
